import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget } from '@eforall/dashboard';
import { AccProspectAlignedAccelerator } from '@interfaces';
import { AppService } from '../../../../../services';
import { ReadonlyAccessWidget } from '../../../readonly-access/readonly-access.widget';
import { EntrepreneurProspectDialogDataService } from '../entrepreneur-prospect-dialog-data.service';
import { getSetup } from './grid/get-setup';

export interface AlignedAccelerator extends AccProspectAlignedAccelerator {
	meetingAcceleratorDisplayText: string,
	meetingLocalDisplayText: string,
	updatedUTC: number,
}

@Component({
	selector: 'entrepreneur-prospect-dialog-aligned-accelerators-part',
	standalone: true,
	imports: [GridContentWidget, ReadonlyAccessWidget],
	templateUrl: './aligned-accelerators.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class EntrepreneurProspectDialogAlignedAcceleratorsPart {

	public dialogBodyHeight = input.required<number>();

	private readonly util = inject(UtilityService);
	public readonly dialogDataService = inject(EntrepreneurProspectDialogDataService);
	private readonly app = inject(AppService);

	public setup = getSetup(this.util, this.dialogDataService);

	// subtracting 70 to account for padding and tabstrip, and 45 for readonly access widget if applicable
	public customHeight = computed(() => this.dialogBodyHeight() - 70 - (this.dialogDataService.isReadonly() ? 45 : 0));

	public alignedAccelerators = computed<AlignedAccelerator[]>(() => {

		const alignedAccs: AlignedAccelerator[] = (this.dialogDataService.dialogData()?.alignedAccs ?? []).map(acc => {

			const accSchedule = this.util.date.formatAccMeetingSlot(acc.meetingStartSlot, acc.accTimeZoneId, true, this.app.data().standardLocalTimezoneId);

			return {
				...acc,
				meetingAcceleratorDisplayText: accSchedule.acceleratorDisplayTime,
				meetingLocalDisplayText: accSchedule.localDisplayTime,
				updatedUTC: Date.now() / 1000,
			}
		}) ?? [];

		return alignedAccs;
	});
}